import { Box, LinearProgress, Typography } from "@mui/material";
import { ReactNode } from "react";

import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

import styles from "../../../../assets/styles/componentStyles/billingStyles/billingUsage.module.scss";

import { billingSubscriptionFeatures } from "../../../../models/axiosModel";
import FeatureFreezeWarning from "./featureFreezeWarning";

type overviewVariant = "purple" | "teal" | "blue" | "orange";

const FEATURE_PRESENTATION: Record<string, { icon: ReactNode; variant: overviewVariant }> = {
    active_contacts: {
        icon: <PeopleOutlineIcon />,
        variant: "purple",
    },
    whatsapp_campaign_messages: {
        icon: <ChatBubbleOutlineIcon />,
        variant: "teal",
    },
    non_ai_voice_minutes: {
        icon: <PhoneOutlinedIcon />,
        variant: "blue",
    },
    users: {
        icon: <PersonOutlineIcon />,
        variant: "orange",
    },
};

const UsageOverviewRow = ({ feature }: { feature: billingSubscriptionFeatures }) => {
    
    const presentation = FEATURE_PRESENTATION[feature.billing_feature_name] || {
        icon: <PersonOutlineIcon />,
        variant: "purple" as overviewVariant,
    };

    const isInfinite = feature.flag_infinite;
    const isFreezed = feature.flag_freeze;
    const used = Number(feature.feature_used_amount);
    const limit = Number(feature.feature_limit_value);
    const percentage = Math.min(Math.max(Number(feature.feature_usage_percent) || 0, 0), 100);
    const resourceName = feature.flag_feature_limit_monthly_reset
        ? `${feature.billing_feature_display_name} / Month`
        : feature.billing_feature_display_name;

    return (
        <Box className={`${styles.overviewRow} ${styles[presentation.variant]}`}>
            
            <Box className={styles.overviewResource}>
                <Box className={styles.overviewIcon}>
                    {presentation.icon}
                </Box>
                <Typography className={styles.overviewResourceName}>
                    {resourceName}
                </Typography>

                {isFreezed && (
                    <FeatureFreezeWarning placement="right" size="medium" />
                )}
            </Box>

            <Typography className={styles.overviewUsedContainer}>
                {isInfinite ? (
                    <span className={styles.greyColorText}>
                        Unlimited
                    </span>
                ) : (
                    <>
                        <span className={styles.greyColorText}>
                            {used}
                        </span>
                        {`/${limit}`}
                    </>
                )}
            </Typography>

            <Box className={styles.overviewProgress}>
                {isInfinite ? (
                    "-"
                ) : (
                    <>
                        <LinearProgress
                            variant="determinate"
                            value={percentage}
                            className={styles.overviewProgressBar}
                        />

                        <Typography className={styles.overviewPercent}>
                            {`${percentage}%`}
                        </Typography>
                    </>
                )}
            </Box>

        </Box>
    );
};

export default UsageOverviewRow;
